import onboardingImg1 from '@/assets/img/onboarding/onboarding-1.png'
import onboardingImg2 from '@/assets/img/onboarding/onboarding-2.png'
import onboardingImg3 from '@/assets/img/onboarding/onboarding-3.png'
import onboardingImg4 from '@/assets/img/onboarding/onboarding-4.png'
import onboardingImg5 from '@/assets/img/onboarding/onboarding-5.png'
import onboardingImg7 from '@/assets/img/onboarding/onboarding-7.png'

export default [
  {
    title: 'Um novo jeito de cuidar do seu dinheiro',
    content:
      '<p>Para  mais flexibilidade e transparência no gerenciamento de suas transações, criamos a <strong>carteira Casar.com.</strong></p>',
    image: onboardingImg1,
    position: {
      top: 'auto',
      right: '-150px',
      bottom: '0',
      left: 'auto',
    },
  },
  {
    title: 'Seus presentes recebidos',
    content:
      'Agora você recebe seus presentes  detalhados na carteira e o valor é somado no saldo disponível para uso. Ao entrar na carteira é descontado o valor da taxa da lista de presentes.',
    image: onboardingImg2,
    position: {
      top: 'auto',
      right: 'auto',
      bottom: '0',
      left: '-230px',
    },
  },
  {
    title: 'Consulte seus saldos',
    content:
      'Você pode acompanhar seu saldo disponível, total recebido, total já utilizado e os valores que ainda entrarão na sua carteira.',
    image: onboardingImg3,
    position: {
      top: 'auto',
      right: '20px',
      bottom: '0',
      left: 'auto',
    },
  },
  {
    title: 'Compre no Shopping Casar.com',
    content:
      '<p>Com seu saldo disponível, você pode comprar os produtos dos seus sonhos no Shopping Casar.com <strong>ganhando 4% do dinheiro de volta.</strong></p>',
    image: onboardingImg4,
    position: {
      top: 'auto',
      right: '-130px',
      bottom: '0',
      left: 'auto',
    },
  },
  {
    title: 'Novas funcionalidades',
    content:
      '<p>Em breve a carteira também irá oferecer novas funcionalidades que possibilitarão utilizar o saldo para comprar produtos em lojas parceiras <strong>ganhando cashback.</strong></p>',
    image: onboardingImg5,
    position: {
      top: 'auto',
      right: '-130px',
      bottom: '0',
      left: 'auto',
    },
  },
  {
    title: 'Detalhes das transações',
    content:
      '<p>Cada transação é detalhada no extrato. Para ver o detalhe basta clicar na transação.',
    image: onboardingImg7,
    position: {
      top: 'auto',
      right: '-70px',
      bottom: '0',
      left: 'auto',
    },
  },
]
